import { Button, Glyphicon, Panel } from 'react-bootstrap'
import React, { Component } from 'react'

import { CREATE_BUFFER_VIEW } from '../../../constants/saxs'

export default class BufferWelcomePage extends Component {
  render() {
    return (
      <Panel>
        <Panel.Body>
          <h2 className="landing-title">Buffers on ISPyB</h2>
          <div style={{ marginLeft: '20px' }}>
            <p className="landing-text">A buffer is the matched solution which in a sample is suspended. </p>
            <br />

            <p className="landing-text"> You should define a buffer on ISPyB if you want to: </p>
            <ul>
              <li>Define beforehand an experiment</li>
              <li>Send your samples by courier</li>
            </ul>
            <br />

            <p className="landing-text">
              If your buffer is not in the list showed on the left you can create a new one.
            </p>
            <br />

            <Button bsStyle="primary" bsSize="large" onClick={() => this.props.setView(CREATE_BUFFER_VIEW)}>
              <Glyphicon glyph="plus" /> New buffer
            </Button>
          </div>
        </Panel.Body>
      </Panel>
    )
  }
}
